export default "__VITE_ASSET__9ePKZKM$__"